import React from "react";
import DateHelper from "../DateHelper/DateHelper";

class PropertyCalendarHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var header_dates = [];
    var idx = 0;

    for (
      var d = new Date(this.props.start_date);
      d <= this.props.end_date;
      d.setDate(d.getDate() + 1)
    ) {
      var date_data =
        this.props.date_data[DateHelper.printDateToScreen(d, "yyy-MM-dd")];
      header_dates.push(
        <div
          className="HeaderDateCell"
          style={{
            left:
              idx * (this.props.view_mode == "monthly" ? 50 : 190) + 160 + "px",
          }}
          key={d}
        >
          {this.renderDate(d)}
          {date_data ? (
            <span
              className="occupancy badge"
              title={I18n.t("overall_property_occupancy")}
            >
              {(
                (date_data.total_rooms_booked_at_property /
                  date_data.total_rooms_at_property) *
                100
              ).toFixed(0)}
              %
            </span>
          ) : null}
        </div>
      );
      idx = idx + 1;
    }

    header_dates.unshift(
      <div className="HeaderDateCell" style={{ left: 0, width: '160px' }} key="blank">
        &nbsp;
      </div>
    );

    return <div className="PropertyCalendarHeader">{header_dates}</div>;
  }

  renderDate(d) {
    if (this.props.view_mode == "monthly") {
      var weekday = DateHelper.printDateToScreen(d, "ccc");
      var weekdate = DateHelper.printDateToScreen(d, "D");
      return (
        <span style={{ lineHeight: "15px", marginBottom: "3px" }}>
          {weekday}
          <br />
          {weekdate}
        </span>
      );
    } else {
      return <span>{DateHelper.printDateToScreen(d, "ccc D")}</span>;
    }
  }
}

export default PropertyCalendarHeader;
